var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#D8D8D8;fill-opacity:0;}\n\t.st1{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-IAM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-125.1667, -40.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-IAM",
    transform: "translate(123, 39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 2.2,
    y: 1.6,
    className: "st0",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st1",
    d: "M16,3.1v9.7l-3.5,0l1.3,2.2l1.6,0v1H4.8v-1l2,0l1.3-2.2l-3.8,0V3.1H16z M11.4,12.7H9.3 L8,14.9h4.7L11.4,12.7z M15,4.1H5.3v7.7H15V4.1z M10.2,5.1c1,0,1.8,0.8,1.8,1.8c0,0.9-0.6,1.6-1.5,1.8l0,0.7l1.2,0v1l-1.2,0 l0,0.5h-1l0-2.3C8.8,8.4,8.3,7.7,8.3,6.9C8.3,5.9,9.2,5.1,10.2,5.1z M10.2,6.1c-0.5,0-0.8,0.4-0.8,0.8c0,0.5,0.4,0.8,0.8,0.8 S11,7.4,11,6.9C11,6.5,10.6,6.1,10.2,6.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIam);
export default __webpack_public_path__ + "static/media/iam.029f73beb912af0e1d51be490909ff56.svg";
export { ForwardRef as ReactComponent };